

@if (lecturer) {
  <div class="lecturer-item">
    <app-lecturer-avatar-name [lecturer]="lecturer" [locketOrgId]="orgId"></app-lecturer-avatar-name>
  
    <button
      (click)="onSelectionChange($event, lecturer.id)"
      pButton
      icon="pi {{ selected ? 'pi-times' : 'pi-plus'}}"
      [ngbTooltip]="selected ? ('admin.si-lecturer-item.remove-btn.tooltip' | translate) : ('admin.si-lecturer-item.add-btn.tooltip' | translate)"
      container="body"
      class="p-button-sm p-button-plain p-button-text p-button-rounded">
    </button>
  </div>
}
